export const EMAIL_CADENCE_PREFERENCES = {
  DAILY: 'Daily',
  WEEKLY: 'Weekly',
  IMMEDIATELY: 'Immediately',
};
export const EMAIL_CADENCE = 'email_cadence';
export const EMAIL = 'email';
export const RequestStatus = /** @type {const} */ ({
  IN_PROGRESS: 'in-progress',
  SUCCESSFUL: 'successful',
  FAILED: 'failed',
  DENIED: 'denied',
  PENDING: 'pending',
  CLEAR: 'clear',
  PARTIAL: 'partial',
  PARTIAL_FAILURE: 'partial failure',
  NOT_FOUND: 'not-found',
});
